




import Vue from 'vue';

export default Vue.extend({
  props: {
    task: Promise,
  },
  data() {
    return {
      show: false,
    };
  },
  watch: {
    task: {
      handler(task: Promise<any>|null) {
        this.show = false;
        if (!task) return;
        this.show = true;
        task.finally(() => {
          this.show = false;
        });
      },
      immediate: true,
    },
  },
});
